module.exports = __webpack_public_path__ + "static/media/biruxBronce112.a0148eab.png";